import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatomoTrackingService } from '../../services/matomo-tracking.service';

@Component({
  selector: 'app-service',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service.component.html',
  styleUrl: './service.component.scss',
})
export class ServiceComponent {
  @Input() destacado: boolean = false;
  @Input() icono: string = '';
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() text: string = '';
  @Input() buttonText: string = '';
  @Input() serviceId: string = '';
  @Input() planName: string = '';

  @Output() buttonClick = new EventEmitter<void>();

  constructor(private matomoService: MatomoTrackingService) {}

  /**
   * Maneja el click del botón con tracking
   */
  onButtonClick(): void {
    this.matomoService.trackEvent(
      'services',
      'button_click',
      `${this.serviceId}_${this.buttonText}`,
      1
    );

    this.buttonClick.emit();
    console.log(`📊 Click en botón: ${this.serviceId} - ${this.buttonText}`);
  }

  /**
   * Abre WhatsApp con mensaje mejorado y datos ocultos - MEJORADO
   */
  openWhatsApp(): void {
    this.matomoService.trackServiceButton({
      section: 'services',
      buttonType: 'whatsapp',
      serviceTitle: this.title,
      actionType: 'contact',
      buttonNumber: 1,
      plan: this.planName || this.title,
    });

    const encryptedData = this.matomoService.getEncryptedTrackingData();
    let hiddenPayload = '';

    if (encryptedData) {
      hiddenPayload = this.matomoService.encodeHidden(encryptedData);
    }

    const visibleMessage = `Buen día, equipo de Onelink. 👋

      Me comunico para realizar una consulta sobre sus servicios.

      ⚠️ Por favor, no modifique el código al inicio de este mensaje para agilizar su atención.

      ➡️ Presione el botón de enviar para conectar con un asesor.`;

    // Agregamos saltos de línea después del payload para separarlo visualmente del texto
    const fullMessage = `🔒 ${hiddenPayload}\n\n${visibleMessage}`;

    const phoneNumber = '582813169200';
    // encodeURIComponent procesará correctamente los saltos de línea (\n)
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodeURIComponent(
      fullMessage
    )}&type=phone_number&app_absent=0`;

    console.log('🔗 Abriendo WhatsApp con mensaje enriquecido y espaciado');
    window.open(whatsappUrl, '_blank');
  }
}
